// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"479":"c5aa97e2","741":"6b2c4304","845":"43df4d5c"}[chunkId] + ".chunk.css";
};